import Vue from 'vue'

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
      function documentHandler(e) {
        if (el.contains(e.target)) {
          return false;
        }
        if (binding.expression) {
          binding.value(e);
        }
      }
      el.__vueClickOutside__ = documentHandler;
      document.addEventListener('click', documentHandler);
    },
    update() {

    },
    unbind(el, binding) {
      document.removeEventListener('click', el.__vueClickOutside__);
      delete el.__vueClickOutside__;
    }
})

// 权限校验
Vue.directive('primission', {
  /**
   * 当被绑定元素插入到DOM时 */
  inserted (el, binding) {
    // console.log(binding.value)
    const primissionCode = binding.value
    const profileStr = localStorage.getItem('profile')
    if (!profileStr)  { // 当本地没有权限时
      (el.parentNode && el.parentNode.removeChild(el)) || (el.style.display = 'none')
      return
    }
    const profileAry = JSON.parse(profileStr)
    const { permissions } = profileAry
    if (permissions && (primissionCode !== undefined && permissions.indexOf(primissionCode) === -1)) {

      // e.style.display = 'inline-block'

      (el.parentNode && el.parentNode.removeChild(el)) || (el.style.display = 'none')
    }
  }
})


// WEBPACK FOOTER //
// ./src/public/xz.js